import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { studyGroupsApi } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { throwApiError } from "../../lms-shared/store/error-handling-actions"
import CurriculumPageWarrper from "./CurriculumPageWarrper";

const CurriculumPageDirectLink = () => {

    const { srstudyGroupId } = useParams()
    const [dispaly, setDispaly] = useState()
    const dispatch = useDispatch()
    const texts = useSelector((state => state.translate.texts))
    const navigate = useNavigate();

    useEffect(() => {
        fetchIsParticipant();
    }, [])

    const fetchIsParticipant = (res) => {
        studyGroupsApi.studyGroupsFilterIdPost(srstudyGroupId, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.studyGroupsFilterError, error: error, statusCode: response?.statusCode, message: "studyGroupsFilterRangePost " + error.message, level: 1, component: "course-actions", line: 28 }))
            }
            else {
                if (resdata?.isParticipant) {
                    navigate(`../${srstudyGroupId}`)
                }
                else {
                    setDispaly(true)
                }
            }
        })
    }
    return <>
        {dispaly && <CurriculumPageWarrper />}
    </>
}
export default CurriculumPageDirectLink